import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
//import { Form, Button, Row } from "react-bootstrap";
import { Button, Grid, Typography } from "@material-ui/core";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
//Inputs
import { FormItem } from "react-material-formik-wizard";
import MDImageUpload from "components/MDImageUpload";
import MDFileUpload from "components/MDFileUpload";

import { getSinglePolicy } from "actions/policyActions";
import { getOrderSingle } from "actions/orderActions";
import { getSingleUser } from "actions/userActions";
import { createNewResponseRequirement } from "actions/responseRequirementActions";

const DetailSchema = Yup.object().shape({
  amount: Yup.string()
    .trim()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Required"),
  expiration: Yup.string()
    .trim()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Required"),
  allergies: Yup.array().of(Yup.string()),
});

const RequirementsStep = ({ next, back }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [values, setValues] = useState([]);
  const [description, setDescription] = useState("");
  console.log(
    "🚀 ~ file: index.js:40 ~ RequirementsStep ~ description:",
    description
  );

  const orderSingle = useSelector((state) => state.orderSingle);
  const { singleOrder } = orderSingle;
  console.log(
    "🚀 ~ file: index.js:37 ~ RequirementsStep ~ singleOrder:",
    singleOrder
  );

  const singleUser = useSelector((state) => state.singleUser);
  const { userSingle } = singleUser;
  console.log(
    "🚀 ~ file: index.js:49 ~ PersonalDetailsStep ~ userSingle:",
    userSingle
  );

  const responseRequirementCreate = useSelector(
    (state) => state.responseRequirementCreate
  );
  const { newResponseRequirement, error, success } = responseRequirementCreate;
  console.log("🚀 ~ file: index.js:58 ~ RequirementsStep ~ success:", success);
  console.log("🚀 ~ file: index.js:58 ~ RequirementsStep ~ error:", error);
  console.log(
    "🚀 ~ file: index.js:58 ~ RequirementsStep ~ newResponseRequirement:",
    newResponseRequirement
  );

  useEffect(() => {
    if (newResponseRequirement?.length) {
      let responseIds = [];
      newResponseRequirement?.map((req) => {
        responseIds.push(req?._id);
      });
      // onRequirement({
      //   name: inputs[0]?.keyType,
      //   value: responseIds,
      // });

      setValues((prevInputs) =>
        prevInputs.map((val) => {
          return { ...val, responseRequirements: responseIds };
        })
      );
    }
  }, [newResponseRequirement?.length]);

  useEffect(() => {
    dispatch(getSingleUser());
  }, [dispatch, userSingle?.length]);

  useEffect(() => {
    dispatch(getOrderSingle(id));
  }, [dispatch, singleOrder?.length, id]);

  useEffect(() => {
    mapValues();
  }, [singleOrder?.policy?.claimRequirements?.length]);
  const mapValues = () => {
    setValues(
      singleOrder?.policy?.claimRequirements?.map((item) => ({
        ...item,
        description: "",
        name: item?.claimRequirementTitle,
        responseRequirement: "",
        value: "",
        responseRequirementType: item?.claimRequirementType,
        responseFor: "claim",
        client: userSingle?._id,
      }))
    );
    // values.amount = values.amount ? values.amount : "";
    // values.expiration = values.expiration ? values.expiration : "";
    // values.allergies = values.allergies ? values.allergies : [];
  };

  const changeHandler = (e) => {
    setValues((prevInputs) => {
      return prevInputs.map((val) => {
        if (val?.claimRequirementTitle === e.target.name) {
          return {
            ...val,
            responseRequirement: e.target.value,
            value: e.target.value,
          };
        }
        return val;
      });
    });
  };

  const changeDescriptionHandler = (e) => {
    setDescription(e.target.value);
  };

  const handleArrayChange = (item) => {
    console.log("🚀 ~ file: index.js:85 ~ handleArrayChange ~ item:", item);
    setValues((prevInputs) =>
      prevInputs.map((val) => {
        console.log("🚀 ~ file: index.js:88 ~ handleArrayChange ~ val:", val);
        return val?.claimRequirementTitle === item?.name
          ? { ...val, responseRequirement: item?.value, value: item?.value }
          : val;
      })
    );
  };

  const handleSubmitResponses = () => {
    const responses = values?.map((item) => {
      return {
        responseRequirement: item?.responseRequirement,
        responseRequirementType: item?.responseRequirementType,
        responseFor: item?.responseFor,
        client: item?.client,
      };
    });
    console.log("🚀 ~ file: index.js:146 ~ responses ~ responses:", responses);

    dispatch(createNewResponseRequirement(responses));
  };

  console.log("🚀 ~ file: index.js:62 ~ RequirementsStep ~ values:", values);

  return (
    <React.Fragment>
      <Formik
        enableReinitialize={true}
        initialValues={values}
        // validationSchema={DetailSchema}
        onSubmit={(values) => {
          console.log(
            "🚀 ~ file: index.js:65 ~ RequirementsStep ~ values:",
            values
          );
          const newValues = {
            values: values,
            description: description,
          };
          console.log(
            "🚀 ~ file: index.js:172 ~ RequirementsStep ~ newValues:",
            newValues
          );
          next(newValues);
        }}
      >
        {({
          isSubmitting,
          values,
          errors,
          handleSubmit,
          handleChange,
          touched,
          handleBlur,
          validateField,
          setFieldValue,
          setFieldTouched,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={3}
              direction="row"
              alignItems="center"
              justify="center"
              width="100%"
              style={{ paddingTop: 50, paddingBottom: 50 }}
            >
              <Grid item xs={12} md={8} lg={8}>
                <MKTypography
                  variant="h4"
                  type="title"
                  color="inherit"
                  style={{ flex: 1 }}
                >
                  Claim Order Requirements
                </MKTypography>
                <MKTypography
                  variant="body"
                  fontSize="medium"
                  opacity={0.8}
                  fontWeight="regular"
                >
                  Ensure to provide the appropriate responses to the
                  requirements below: -
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <FormItem
                  type="text"
                  multiline
                  name="description"
                  label="Claim Description"
                  placeholder="Give a description of the event leading to this claim"
                  onChange={changeDescriptionHandler}
                  onBlur={handleBlur}
                  value={description}
                  error={errors.description}
                  touched={touched.description}
                />
              </Grid>
              {values?.map((item, index) => (
                <>
                  {item?.claimRequirementType === "text" && (
                    <Grid key={index} item xs={12} md={8} lg={8}>
                      <FormItem
                        type="text"
                        name={item?.name}
                        label={item?.claimRequirementTitle}
                        placeholder={`Enter ${item?.claimRequirementTitle}`}
                        onChange={changeHandler}
                        onBlur={handleBlur}
                        value={item?.value}
                        error={errors.responseRequirement}
                        touched={touched.responseRequirement}
                      />
                    </Grid>
                  )}
                  {item?.claimRequirementType === "number" && (
                    <Grid item xs={12} md={8} lg={8}>
                      <FormItem
                        type="number"
                        name={item?.name}
                        label={item?.claimRequirementTitle}
                        placeholder={`Enter ${item?.claimRequirementTitle}`}
                        onChange={changeHandler}
                        onBlur={handleBlur}
                        value={item?.value}
                        error={errors.responseRequirement}
                        touched={touched.responseRequirement}
                      />
                    </Grid>
                  )}
                  {/* {item?.claimRequirementType === "image" && (
                    <Grid item xs={12} md={8} lg={8}>
                      <FormItem
                        type="file"
                        accept="image/*"
                        onChange={(event, form) => {
                          console.log(event.currentTarget.files[0]);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name={item?.name}
                        label={`${item?.claimRequirementTitle} - Upload image file`}
                        placeholder={`Upload ${item?.claimRequirementTitle}`}
                        // onChange={handleChange}
                        onBlur={handleBlur}
                        value={item?.value}
                        error={errors.responseRequirement}
                        touched={touched.responseRequirement}
                      />
                    </Grid>
                  )}
                  {item?.claimRequirementType === "file" && (
                    <Grid item xs={12} md={8} lg={8}>
                      <FormItem
                        type="file"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name={item?.name}
                        label={`${item?.claimRequirementTitle} - Upload document file`}
                        placeholder={`Upload ${item?.claimRequirementTitle}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={item?.value}
                        error={errors.responseRequirement}
                        touched={touched.responseRequirement}
                      />
                    </Grid>
                  )} */}
                  {item?.claimRequirementType === "file" && (
                    <Grid item xs={12} md={8} lg={8}>
                      <MDFileUpload
                        title={item?.claimRequirementTitle}
                        uploadType={item?.responseRequirementType}
                        valueType={item?.value}
                        value={item?.value}
                        name={item?.claimRequirementTitle}
                        onFileChange={(item) => handleArrayChange(item, item)}
                      />
                    </Grid>
                  )}
                  {item?.claimRequirementType === "image" && (
                    <Grid item xs={12} md={8} lg={8}>
                      <MDImageUpload
                        title={item?.claimRequirementTitle}
                        uploadType={item?.responseRequirementType}
                        valueType={item?.value}
                        value={item?.value}
                        name={item?.claimRequirementTitle}
                        onImageChange={(item) => handleArrayChange(item, item)}
                      />
                    </Grid>
                  )}
                </>
              ))}
            </Grid>
            <Grid
              container
              spacing={0}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item md={1} lg={1}>
                <MKButton
                  disabled={isSubmitting}
                  onClick={(e) => back(e, values)}
                >
                  Back
                </MKButton>
              </Grid>
              <Grid item md={7} lg={7} />
              <Grid item md={2} lg={2}>
                <MKButton disabled={success} onClick={handleSubmitResponses}>
                  Submit Requirements
                </MKButton>
              </Grid>
              <Grid item md={1} lg={1}>
                <MKButton
                  disabled={
                    isSubmitting ||
                    Object.entries(errors).length > 0 ||
                    newResponseRequirement?.length === 0 ||
                    newResponseRequirement === undefined
                  }
                  type="submit"
                >
                  Next
                </MKButton>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default RequirementsStep;
